
export const textFieldLabelStyle = {
    fontSize: "12px",
    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
    fontWeight: "bold",
}

export const selectFieldLabelStyle = {
    fontSize: "12px",
    color: process.env.REACT_APP_ENTERPRISE_COLOUR,
    fontWeight: "bold",
    marginBottom: '5px'
}